import { Component, input, output } from '@angular/core';
import type { EChartsOption } from 'echarts';
import type { EChartsType } from 'echarts/core';
import { NgxEchartsDirective } from 'ngx-echarts';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

/**
 * Generic, "dumb" echarts bar chart - it renders whatever `options` it's given and reports
 * back init/click events. All data shaping, series/tooltip/axis configuration and formatting
 * lives in the caller (e.g. `AdminEventAnalyticsOverviewBarGraphsComponent`), keeping this
 * component reusable for any bar chart in the app rather than tied to one dataset's shape.
 */
@Component({
  imports: [NgxEchartsDirective, NgxSkeletonLoaderModule],
  selector: 'app-bar-graph',
  templateUrl: './bar-graph.component.html',
})
export class BarGraphComponent {
  public readonly options = input.required<EChartsOption>();
  /** Fixed height for both the real chart canvas and the loading skeleton. */
  public readonly height = input<number>(280);
  public readonly loading = input<boolean>(false);

  public readonly chartInit = output<EChartsType>();
  public readonly chartClick = output<unknown>();

  public onChartInit(chart: EChartsType): void {
    this.chartInit.emit(chart);
  }

  public onChartClick(params: unknown): void {
    this.chartClick.emit(params);
  }
}
